import React from 'react';
import Slider from 'react-slick';
import classNames from 'clsx';

import Icons from '../../constants/Icons';

import '../../assets/slick/slick.css';
import '../../assets/slick/slick-theme.css';
import { useApplicationParams, useLanguage } from '../../context';

const PrevArrow = ({ className, style, onClick }) => {
  const buttonClassName = classNames(className, 'carousel-button', 'carousel-button-back');

  return (
    <img
      className={buttonClassName}
      src={Icons.carouselBtn}
      alt="prev"
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    />
  );
};

const NextArrow = ({ className, style, onClick }) => {
  const buttonClassName = classNames(className, 'carousel-button');

  return (
    <img
      className={buttonClassName}
      src={Icons.carouselBtn}
      alt="next"
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    />
  );
};

const Carousel = ({
  ItemComponent,
  data = [],
  itemsToShow = 2,
  showHalfOfNext = false,
  showDots = false,
  showArrows = false,
}) => {
  const { isWeb } = useApplicationParams();
  const { isRtl } = useLanguage();

  const images = isRtl ? data.slice().reverse() : data;

  const slideClassName = classNames('slick-item-div', {
    'slick-item-div-lg': isWeb,
  });

  return (
    <div className={`slick-outer-div ${showHalfOfNext && 'show-half-of-next'}`}>
      <div className="slick-inner-div">
        <Slider
          dots={showDots}
          arrows={showArrows}
          infinite={false}
          speed={500}
          rtl={isRtl}
          slidesToShow={itemsToShow}
          slidesToScroll={itemsToShow}
          initialSlide={0}
          centerMode={showHalfOfNext}
          centerPadding={showHalfOfNext ? '7%' : '0%'}
          nextArrow={showArrows ? <NextArrow /> : ''}
          prevArrow={showArrows ? <PrevArrow /> : ''}
        >
          {images.map((dataItem) => (
            <div className={slideClassName} key={Math.random()}>
              <ItemComponent data={dataItem} />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Carousel;
